import {
  formatPercentageValue,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, UserInteractionData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const avgUserInteractions: KpiHandler = {
  type: 'KpiTile',
  handler: (data: UserInteractionData): KpiData => {
    const { totalUserInteractions, totalUserInteractionsDelta } = data;

    const formattedValue = formatPercentageValue(totalUserInteractions);
    const tag = {
      text: formatPercentageValue(Math.abs(totalUserInteractionsDelta)),
      isPositiveValue: totalUserInteractionsDelta >= 0,
    };

    return createKpiTileItem(
      'Average User Interactions',
      formattedValue,
      totalUserInteractionsDelta ? tag : []
    );
  },
};

export default avgUserInteractions;
